$(document).ready(function () {
    const swiper = new Swiper('.home-categories-caption .swiper', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const swiperAboutUs = new Swiper('.why-choose-us-header-hero-section .banner .swiper', {
        loop: true,
        pagination: false,
        navigation: false,
        autoplay: {
            delay: 3000,     // 3 seconds
            disableOnInteraction: false, // continues autoplay after user interaction
        },
    });
    const swiperDetails = new Swiper('.product-details-recommend-slider .swiper', {
        loop: true,
        slidesPerView: 3,       // Show 3 slides per view
        spaceBetween: 30,       // 30px gap between slides
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
         breakpoints: {
            0: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3
            },
        }
    });    
    
     $('.my-background-video').bgVideo({
        loop: true,
        showPausePlay: false,
        pauseAfter: 0, 
        muted: true,
        autoplay: true
    });
    $('.goBackBtn').on('click', function () {
        window.history.back();
    });
    
    $('.website-navbar .navbar-toggler').click(function (e) {
        if(window.innerWidth < 992){
            $("body").toggleClass("overflow-y-hidden")
        }        
    });
    let sidebar = $(".mobile-navbar-collapse-sidebar");
    if(window.innerWidth < 992){
        $(".mobile-navbar-collapse-sidebar").remove();
        $(".website-navbar").after(sidebar);
    } 
    // Collapse navbar on nav-link click (mobile)
    $('.jq-website-navbar.navbar-collapse .nav-link').on('click', function () {
        $('.jq-website-navbar.navbar-collapse').collapse('hide');        
        $("body").removeClass("overflow-y-hidden")
    });

    // Collapse navbar when browser back/forward button is used
    $(window).on('pageshow', function () {
        if ($('.jq-website-navbar.navbar-collapse').hasClass('show')) {
            $('.jq-website-navbar.navbar-collapse').collapse('hide');      
            $("body").removeClass("overflow-y-hidden")
        }
    });
})